  <mat-expansion-panel #panel="matExpansionPanel"
                       class="panel-container"
                       [ngClass]="{'panel-container--error': canMarkInvalidSection && form.invalid}">
    <mat-expansion-panel-header class="panel-header"
                                collapsedHeight="72px"
                                expandedHeight="76px">
      <ifbp-form-details-section-header [config]="headerConfig"
                                        [iconType]="canMarkInvalidSection && form.invalid ? IconType.Warning : form.dirty ? IconType.Changes : IconType.Default">
      </ifbp-form-details-section-header>
    </mat-expansion-panel-header>
    <div>
      <form class="form"
            [formGroup]="form">
        <div class="form__section">
          <div class="form__row">
            <mat-form-field class="form__field"
                            appearance="outline">
              <mat-label>Company Name (legal entity name)</mat-label>
              <input matInput
                     formControlName="name" />
              <mat-error *ngIf="form.get('name')?.errors | hasControlError:['required']">Company name is required.</mat-error>
              <mat-error *ngIf="form.get('name')?.errors | hasControlError:['maxlength']">Company name is too long.</mat-error>
            </mat-form-field>

            <mat-form-field class="form__field"
                            appearance="outline">
              <mat-label>EIN</mat-label>
              <input matInput
                     formControlName="ein"
                     mask="00-0000000" />
              <mat-error *ngIf="form.get('ein')?.errors | hasControlError:['required']">EIN is required.</mat-error>
              <mat-error *ngIf="form.get('ein')?.errors | hasControlError:['pattern']">Please enter a valid EIN.</mat-error>
            </mat-form-field>
          </div>

          <div class="form__row">
            <mat-form-field class="form__field"
                            appearance="outline">
              <mat-label>Ownership</mat-label>
              <mat-select formControlName="entityType">
                <mat-option *ngFor="let option of ownershipOptions"
                            [value]="option.value">
                  {{ option.name }}
                </mat-option>
              </mat-select>
              <mat-error>Ownership is required.</mat-error>
            </mat-form-field>

            <mat-form-field class="form__field"
                            appearance="outline">
              <mat-label>Primary phone number</mat-label>
              <input matInput
                     formControlName="phone"
                     mask="(000) 000-0000" />
              <mat-error *ngIf="form.get('phone')?.errors | hasControlError:['required']">Primary phone number is required.</mat-error>
              <mat-error *ngIf="form.get('phone')?.errors | hasControlError:['pattern']">Please enter a valid phone number.</mat-error>
            </mat-form-field>
          </div>
        </div>

        <span class="form__subheader">Business address</span>
        <ifbp-address-form [form]="form.controls.address"></ifbp-address-form>

        <span class="form__subheader">Other business information</span>
        <div class="form__section">
          <div class="form__row">
            <mat-form-field class="form__field"
                            appearance="outline">
              <mat-label>DBA</mat-label>
              <input matInput
                     formControlName="dba" />
              <mat-error *ngIf="form.get('dba')?.errors | hasControlError:['maxlength']">DBA is too long.</mat-error>
            </mat-form-field>

            <mat-form-field class="form__field"
                            appearance="outline">
              <mat-label>Time in business</mat-label>
              <mat-select formControlName="timeInBusiness">
                <mat-option *ngFor="let option of timeInBusinessOptions"
                            [value]="option.value">
                  {{ option.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('timeInBusiness')?.errors | hasControlError:['required']">Time in business is required.</mat-error>
            </mat-form-field>
          </div>

          <div class="form__row">
            <mat-form-field class="form__field"
                            appearance="outline">
              <mat-label>Business description</mat-label>
              <input matInput
                     formControlName="description" />
              <mat-error *ngIf="form.get('description')?.errors | hasControlError:['required']">Description is required.</mat-error>
              <mat-error *ngIf="form.get('description')?.errors | hasControlError:['maxlength']">Description is too long.</mat-error>
            </mat-form-field>

            <mat-form-field class="form__field"
                            appearance="outline">
              <mat-label>Monthly sales</mat-label>
              <input matInput
                     formControlName="monthlySales"
                     [prefix]="form.get('monthlySales')?.value ? '$' : ''"
                     mask="separator.2"
                     thousandSeparator="," />
              <mat-error *ngIf="form.get('monthlySales')?.errors | hasControlError:['min']">Monthly sales is too small.</mat-error>
              <mat-error *ngIf="form.get('monthlySales')?.errors | hasControlError:['max']">Monthly sales is too large.</mat-error>
            </mat-form-field>
          </div>
          <div class="form__row">
            <mat-form-field class="form__field"
                            appearance="outline">
              <mat-label>Requested amount</mat-label>
              <input matInput
                     formControlName="requestedAmount"
                     [prefix]="form.get('requestedAmount')?.value ? '$' : ''"
                     mask="separator.2"
                     thousandSeparator="," />
              <mat-error *ngIf="form.get('requestedAmount')?.errors | hasControlError:['min']">Requested amount is too small.</mat-error>
              <mat-error *ngIf="form.get('requestedAmount')?.errors | hasControlError:['max']">Requested amount is too large.</mat-error>
            </mat-form-field>
            <div class="form__field"></div>
          </div>
        </div>
      </form>

    </div>
  </mat-expansion-panel>
